const ExpandedOrCollapsed = {
  EXPANDED: "expanded",
  COLLAPSED: "collapsed"
};

ExpandedOrCollapsed.ALL = Object.values(ExpandedOrCollapsed);

export default ExpandedOrCollapsed;
